export const EditorConfig = {
  defaultToolOptions: {
    strokeColor: "#d4d4d4",
    fillColor: "#d4d4d4",
  },
  renderOptions: {
    hoverOutlineColor: "#2563eb",
    hoverOutlineWidth: 2,
    selectionBoxStrokeColor: "#2563eb",
    selectionBoxStrokeSize: 1.5,
    selectionBoxFillColor: "rgba(37, 99, 235, 0.12)",
  },
  handleOptions: {
    cornerSize: 8,
    rotationPadding: 15,
    rotationRadius: 10,
    cornerFillColor: "#ffffff",
    cornerStrokeColor: "#171717",
    cornerStrokeWidth: 1.5,
    edgeStrokeColor: "#2563eb",
    edgeStrokeWidth: 1.5,
    rotationFillColor: "#2563eb",
    rotationStrokeColor: "#ffffff",
    rotationStrokeWidth: 2,
  },
}
